import { IndividualExamStatusDto } from '@/api/generated';

export type ExamineeExamTranslation = {
  areaScopeLabel: string;
  areasIntro: string;
  areaStatusFailed: string;
  areaStatusOpen: string;
  areaStatusPassed: string;
  back: string;
  carriedOverPassedOn: string;
  carriedOverSubtitle: string;
  carriedOverTitle: string;
  commentUpdatedAt: string;
  commissionCommentsTitle: string;
  commissionEvaluating: string;
  drawnReportLabel: string;
  examLabel: string;
  examName: string;
  finishedNoCommentsInfo: string;
  loadError: string;
  noAttachments: string;
  noSharedReports: string;
  notStartedInfo: string;
  pdfPreviewError: string;
  pdfPreviewLoading: string;
  pdfPreviewPager: string;
  reportFallbackTitle: string;
  reportNotSharedYet: string;
  reportPreviewOnlyInProgress: string;
  reportQuestionsTitle: string;
  roleChairman: string;
  roleHrbp: string;
  sharedAt: string;
  startedAt: string;
  status: Record<IndividualExamStatusDto, string>;
  statusHeaderLabel: string;
  subcategoryGraded: string;
  subcategoryNotGraded: string;
  subquestionsTitle: string;
  title: string;
};

export const examineeExamTranslation: ExamineeExamTranslation = {
  areaScopeLabel: 'Scope',
  areasIntro:
    'Below you can see the exam areas. Under each area is a list of subcategories — these are what the commission pays attention to and what is worth talking about. You do not see scores during the exam, and the result (passed / failed) is shown only after the exam is finished.',
  areaStatusFailed: 'FAILED',
  areaStatusOpen: 'IN PROGRESS',
  areaStatusPassed: 'PASSED',
  back: 'Back to my certifications',
  carriedOverPassedOn: 'Passed on {{date}}',
  carriedOverSubtitle:
    'These areas were passed in an earlier term of this stage and carry over as passed — you do not need to retake them.',
  carriedOverTitle: 'Passed in a previous term',
  commentUpdatedAt: 'Updated {{date}}',
  commissionCommentsTitle: 'Commission comments',
  commissionEvaluating: 'The commission is evaluating you',
  drawnReportLabel: 'Your drawn report',
  examLabel: 'Exam',
  examName: 'Practical certification',
  finishedNoCommentsInfo: 'The commission did not leave any general comments for this exam.',
  loadError: 'Failed to load exam view.',
  noAttachments: 'No attachments to preview yet.',
  noSharedReports: 'No reports have been shared with you yet. Please wait for the commission.',
  notStartedInfo:
    'The exam is not in progress. Reports will be visible once the commission starts the exam.',
  pdfPreviewError: 'Failed to load PDF preview.',
  pdfPreviewLoading: 'Loading PDF preview…',
  pdfPreviewPager: 'Page {{page}} of {{total}}',
  reportFallbackTitle: 'Report',
  reportNotSharedYet: 'The commission will share this report with you during the exam.',
  reportPreviewOnlyInProgress:
    'The report preview is only available while the exam is in progress.',
  reportQuestionsTitle: 'Report questions',
  roleChairman: 'Commission chairman',
  roleHrbp: 'HRBP',
  sharedAt: 'Shared {{date}}',
  startedAt: 'Started {{date}}',
  status: {
    [IndividualExamStatusDto.Cancelled]: 'Cancelled',
    [IndividualExamStatusDto.Draft]: 'Draft',
    [IndividualExamStatusDto.Failed]: 'Failed',
    [IndividualExamStatusDto.Passed]: 'Passed',
    [IndividualExamStatusDto.Started]: 'In progress',
  },
  statusHeaderLabel: 'Status',
  subcategoryGraded: 'Graded',
  subcategoryNotGraded: 'Not graded yet',
  subquestionsTitle: 'Sub-questions',
  title: 'Practical exam',
};
